import React, { ReactNode } from 'react';
import cx from 'classnames';

export interface BoxProps {
  className?: string;
  children: ReactNode;
}

export function Box({ className, children }: BoxProps) {
  return (
    <div
      className={cx(
        className,
        'block rounded border border-solid v2-border-neutral-300 p-4'
      )}
    >
      {children}
    </div>
  );
}
